var React = require('react');

function Kiss (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM168,240a32,32,0,1,1,32-32A32,32,0,0,1,168,240ZM304,396c0,19.2-28.7,41.5-71.5,44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5,20.8-13.5,20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2,0-14.8l17-7.2c13-5.5,20.8-13.5,20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5,3.6-15.4,42.8,2.5,71.5,24.8,71.5,44,0,13-13.4,27.3-35.2,36C290.6,368.7,304,383,304,396Zm24-156a32,32,0,1,1,32-32A32,32,0,0,1,328,240Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M328,176a32,32,0,1,0,32,32A32,32,0,0,0,328,176Zm-160,0a32,32,0,1,0,32,32A32,32,0,0,0,168,176Z","className":"fa-primary","key":2})]);
}

Kiss.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = Kiss;

Kiss.default = Kiss;
